var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#bd591d",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M23.915 26.182c3.395-1.02 6.796-5.172 6.039-11.585C28.397 1.405 10.874-1.215 5.54 9.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd591d",
    d: "M1.06 16.961L.713 4.182A1.539 1.539 0 0 1 2.9 2.746L7.14 7.18l6.123.398a1.539 1.539 0 0 1 .306 2.6L3.556 18.125A1.539 1.539 0 0 1 1.06 16.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUndo);
export default __webpack_public_path__ + "static/media/arrow-undo.6ee5b11e1ab28ddb1fa10c30c22cc42b.svg";
export { ForwardRef as ReactComponent };